import React from 'react';
export const ModalContext = /*#__PURE__*/React.createContext({});
export const {
  Provider: ModalContextProvider
} = ModalContext;